/* eslint-disable no-new-func */
const CryptoJS = require('crypto-js')

/**
 * 加密
 * @param data
 * @param secretKey
 * @returns {string}
 */
export function aseEncrypt (data, iv = '37c21764517681cf', secretKey = '57dbb0f5a0125716af698ef9bd4473ca') {
  if (typeof (data) === 'object') {
    data = JSON.stringify(data)
  }
  const key = CryptoJS.enc.Utf8.parse(CryptoJS.MD5(secretKey).toString())
  // const iv = CryptoJS.enc.Utf8.parse(CryptoJS.MD5(key).toString().substr(0, 16))
  const result = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return result.toString()
}

/**
 * 解密
 * @param {*} data
 * @param {*} secretKey
 */
export function aseDecrypt (data) {
  const key = CryptoJS.enc.Utf8.parse('57dbb0f5a0125716af698ef9bd4473ca')
  const iv = CryptoJS.enc.Utf8.parse('37c21764517681cf')
  const decrypted = CryptoJS.AES.decrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding
  })
  let str = CryptoJS.enc.Utf8.stringify(decrypted)

  /**
   * 有一个符号 既不是空白符 也不是换行符 也不是空格符
   * 叫终止符
   * 通过 JSON.stringify(str) 就能看到：\u0000 导致了JSON.parse 失败
   */
  let str2 = str.replace(/\u0000*/g, '')
  return JSON.parse(str2)
}



// WEBPACK FOOTER //
// ./src/utils/crypto.js